import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servConsultaAcesso from "../../services/login/servConsultaAcesso"

const CidadesSearchField = ({ field, id, setOpenError, setErrorMessage, disabled=false, onKeyDown, className="" }) => {

    const loadCidades = async (inputValue) => {
        try {
            
            const response = await servConsultaAcesso.RecuperarCidades(inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;
        } catch (err) {
            setOpenError(true);
            setErrorMessage(err?.response?.data?.Message);
        }
    }

    const mapResponseToValuesAndLabels = (data) => {
        return {
            value: data.Id,
            label: data.Nome
        }
    }

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Selecione uma cidade"
            loadOptions={loadCidades}
            defaultOptions
            isDisabled={disabled}
            styles={SearchFieldStyles}
            {...field}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { CidadesSearchField }